export const MyWarrantyRouting = [
  {
    path: "/maintenance/myWarranty",
    name: "maintenance-myWarranty-list",
    meta: { title: "我的保修任务" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-myWarranty" */ "@/views/maintenance/myWarranty/list/index.vue"
      ),
  },
  // {
  //   hidden: true,
  //   path: "/maintenance/myWarranty/create",
  //   name: "maintenance-myWarranty-create",
  //   meta: { title: "新建保修工单", comName: "myWarrantyFormCreate" },
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "maintenance-myWarranty" */ "@/views/maintenance/myWarranty/form-create/index.vue"
  //     ),
  // },
  // {
  //   hidden: true,
  //   path: "/maintenance/myWarranty/edit/:id",
  //   name: "maintenance-myWarranty-edit",
  //   meta: { title: "编辑保修工单", comName: "myWarrantyFormCreate" },
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "maintenance-myWarranty" */ "@/views/maintenance/myWarranty/form-create/index.vue"
  //     ),
  // },
  {
    hidden: true,
    path: "/maintenance/myWarranty/detail/:id",
    name: "maintenance-myWarranty-detail",
    meta: { title: "我的保修任务详情" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-myWarranty" */ "@/views/maintenance/myWarranty/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/myWarranty/flowPrint/:id",
    name: "maintenance-myWarranty-flow-print",
    meta: { title: "我的保修任务打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-myWarranty" */ "@/views/maintenance/myWarranty/flow-print/index.vue"
      ),
  },
];
